import { useState } from "react";

import { EventsLibraryExportDialog } from "@/components/ui/admin/events/EventsLibraryExportDialog";
import { Button } from "@/components/ui/Button";
import type {
  EventLibraryCategoryFilter,
  EventLibraryDateFilters,
  EventLibraryTab,
} from "@/core/services/types/event.types";
import { useTranslations } from "@/lib/useTranslations";

interface EventsLibraryExportButtonProps {
  tab: EventLibraryTab;
  category: EventLibraryCategoryFilter;
  dateFilters: EventLibraryDateFilters;
  searchQuery: string;
  total: number;
}

export function EventsLibraryExportButton({
  tab,
  category,
  dateFilters,
  searchQuery,
  total,
}: EventsLibraryExportButtonProps) {
  const t = useTranslations("events.library");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="secondary"
        className="px-3 py-1.5 text-sm"
        disabled={total === 0}
        onClick={() => setIsOpen(true)}
      >
        {t("export.action")}
      </Button>

      <EventsLibraryExportDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        tab={tab}
        category={category}
        dateFilters={dateFilters}
        searchQuery={searchQuery}
        total={total}
      />
    </>
  );
}
